module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "purchases-header"
  }, [_c('Header', [_vm._v("История заявок")])], 1), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.selectItems), function(item) {
    return _c('router-link', {
      key: item.text,
      staticClass: "tab",
      attrs: {
        "to": {
          name: item.to
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b2c2bac","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/purchases/Index.vue
// module id = 077db9037d8f691beca1
// module chunks = 63